// extracted by mini-css-extract-plugin
export default {"content":"Subscribe_content__jKnf7","h1":"Subscribe_h1__Z1ffW","p":"Subscribe_p__ncpLQ","input":"Subscribe_input__NlFrS","button":"Subscribe_button__EMdVI"};